import { Globe2, Satellite, Moon } from "lucide-react";
import { BASEMAPS, REGIONS } from "@/lib/map";

const BTN = "flex items-center gap-1.5 px-3 h-8 text-[10px] font-mono uppercase tracking-wider transition-colors";
const ICONS = { satellite: Satellite, dark: Moon };

export const BasemapToggle = ({ value, onChange }) => (
  <div className="flex border border-white/10 bg-atlas-void/80 backdrop-blur" data-testid="basemap-toggle">
    {Object.entries(BASEMAPS).map(([id, b]) => {
      const Icon = ICONS[id];
      return (
        <button
          key={id}
          onClick={() => onChange(id)}
          data-testid={`basemap-${id}`}
          className={`${BTN} ${value === id ? "bg-atlas-cyan text-atlas-void" : "text-atlas-secondary hover:text-white"}`}
        >
          <Icon className="w-3.5 h-3.5" />
          {b.label}
        </button>
      );
    })}
  </div>
);

export const RegionMenu = ({ value, onSelect }) => (
  <div
    className="inline-flex flex-wrap items-center border border-white/10 bg-atlas-void/85 backdrop-blur max-w-full"
    data-testid="region-menu"
  >
    <span className="flex items-center gap-1.5 px-3 h-8 text-[10px] font-mono uppercase tracking-[0.2em] text-atlas-cyan/60 border-r border-white/10">
      <Globe2 className="w-3.5 h-3.5" /> Region
    </span>
    {REGIONS.map((r) => (
      <button
        key={r.id}
        onClick={() => onSelect(r)}
        data-testid={`region-${r.id}`}
        className={`${BTN} px-2.5 ${value === r.id ? "bg-atlas-cyan text-atlas-void" : "text-atlas-secondary hover:text-white"}`}
      >
        {r.label}
      </button>
    ))}
  </div>
);
